import React, { Component } from 'react';
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import NewAddress from '../New-Address/New-Address';

class OpcaoEntrega extends Component {
    constructor(props) {
        super(props);

        this.selecionaEndereco = this.selecionaEndereco.bind(this);
        this.toggleModalEndereco = this.toggleModalEndereco.bind(this);
        this.salvarEndereco = this.salvarEndereco.bind(this);
        this.alterarEndereco = this.alterarEndereco.bind(this);
        this.calcularFrete = this.calcularFrete.bind(this);
        this.handleRadio = this.handleRadio.bind(this);
        this.exibeComplemento = this.exibeComplemento.bind(this);
        this.modalEscolherFrete = this.modalEscolherFrete.bind(this);
        this.verificarRestricaoEntrega = this.verificarRestricaoEntrega.bind(this);



        this.state = {
            modalEndereco: false,
            valorFrete: this.props.valorFrete,
            isLoadingEndereco: false,

            enderecos: this.props.enderecos,
            indexEnderecoSelecionado: 0,
            cepSelecionado: (!!this.props.enderecos && this.props.enderecos.length > 0) ? this.props.enderecos[0].cep : '',
            mensagem: this.props.mensagem
        };

    }

    componentDidUpdate(prevProps) {
        if (prevProps.opcaoEntrega !== this.props.opcaoEntrega) {
            this.setState({
                enderecos: this.props.enderecos,
            }, () => this.selecionaEndereco(0))
        }

        if (prevProps.mensagem !== this.props.mensagem) {
            this.setState({ mensagem: this.props.mensagem })
        }

    }

    handleRadio(e) {
        if (e.target.value === "2") {
            this.selecionaEndereco(0);
        }
        this.props.handleRadio(e);
    }

    selecionaEndereco(_index) {
        if (this.props.enderecos.length > 0) {
            this.setState({
                indexEnderecoSelecionado: _index,
                cepSelecionado: this.props.enderecos[_index].cep,
            });
            this.props.limparMensagem();
        }
    }

    toggleModalEndereco() {
        this.setState({ modalEndereco: !this.state.modalEndereco })
    }

    salvarEndereco(_end) {
        this.props.salvarEndereco(_end)
        this.toggleModalEndereco();
    }

    calcularFrete() {
        const _cepSelecionado = this.state.cepSelecionado,
            _index = this.state.indexEnderecoSelecionado,
            _idEnd = this.props.enderecos[_index].id;
        this.props.calcularFrete(_cepSelecionado, _idEnd);
    }

    alterarEndereco() {
        this.props.toggleFrete(false);
    }

    exibeComplemento(endereco) {
        const { complemento } = endereco;

        if (complemento == null) {
            return '';
        }

        if (complemento.length < 1) {
            return '';
        }

        return `(${complemento})`;
    }

    modalEscolherFrete() {
        this.props.toggleModalEscolherFrete();
    }

    verificarRestricaoEntrega() {
        window.open('https://www2.correios.com.br/sistemas/precosPrazos/restricaoentrega')
    }



    // verificarRestricaoEntregaOriginal() {
    //     const options = {
    //         method: 'POST',
    //         url: 'https://www2.correios.com.br/sistemas/precosPrazos/restricaoentrega/resultado.cfm',
    //         url: 'https://www2.correios.com.br/sistemas/precosPrazos/restricaoentrega',

    //         headers: {
    //             accept: 'text/html',
    //             'content-type': 'application/x-www-form-urlencoded'
    //         },
    //         data: { servico: '04014', cepOrigem: '01525-000', cepDestino: '20760-570' }
    //     };

    //     axios.request(options).then(response => {
    //         const newTab = window.open();
    //         if (newTab) {
    //             newTab.document.open();
    //             newTab.document.write(response.data);
    //             newTab.document.close();
    //         } else {
    //             console.error('Não foi possível abrir uma nova aba.');
    //         }
    //         console.log("###Response", response.data);

    //     }).catch(error => {
    //         console.error(error);
    //     });
    // }

    render() {

        return (
            <div className="card">
                <div className="card-body px-1">
                    <div className="row no-gutters px-3">
                        {!this.props.verificaDigital() ? (
                            <div className="col-12 py-2">
                                {this.props.codMembro && (
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio" name="opcaoEntrega" id="orgBase" checked={this.props.opcaoEntrega === "2"} value="2" onChange={this.handleRadio} />
                                        <label className="form-check-label" htmlFor="orgBase">
                                            <strong>Receber via organização de base</strong>
                                        </label>
                                        <p><small>O pedido será enviado ao local de impresso cadastrado, sem custo adicional.</small></p>
                                    </div>
                                )}
                                <div className="form-check">
                                    <input className="form-check-input" type="radio" name="opcaoEntrega" id="correio" checked={this.props.opcaoEntrega === "1"} value="1" onChange={this.handleRadio} disabled={this.props.verificaDigital()} />
                                    <label className="form-check-label" htmlFor="correio">
                                        <strong>Receber por correio</strong>
                                        {/* <small className="text-danger"> (o usuário não possui endereço cadastrado)</small> */}
                                    </label>
                                    <p><small>O pedido será enviado ao endereço selecionado, com custo adicional de frete.</small></p>
                                </div>
                            </div>
                        ) : (
                            <div className="col-12 py-2">
                                <p>O pedido contém apenas produtos digitais.</p>
                            </div>
                        )}
                        {this.props.opcaoEntrega === "1" && (
                            <div className="col-12 py-2">
                                {this.props.enderecos.length > 0 && (
                                    <div className="row no-gutters">
                                        {this.props.enderecos.map((end, index) => {
                                            return (
                                                <div key={`end-${index}`} onClick={() => this.selecionaEndereco(index)}
                                                    className={`col-4 px-1 py-2 pointer ${index === this.state.indexEnderecoSelecionado ?
                                                        (this.props.freteAtivo ? 'offset-4 mb-3' : '')
                                                        :
                                                        (this.props.freteAtivo ? 'd-none' : '')}`}>
                                                    <div className={`card card-endereco ${index === this.state.indexEnderecoSelecionado ? 'ativo' : ''}`}>
                                                        <div className={`card-header`}>
                                                            <div className="row no-gutters">
                                                                <div className="col-10 px-0">
                                                                    {end.titulo}
                                                                </div>
                                                                {index === this.state.indexEnderecoSelecionado && (
                                                                    <div className="col-2 px-0 text-center">
                                                                        <span className={`badge-success badge-circle-sm border border-white text-white`}><small>✔</small></span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="card-body">
                                                            <div className="row no-gutters">
                                                                <div className="col-12 px-0">
                                                                    <div className="row py-1 no-gutters">
                                                                        <div className="col-12 text-left">
                                                                            <span>{end.cep}</span>
                                                                        </div>
                                                                        <div className="col-12 text-left">
                                                                            <span>{end.logradouro}, {end.numero} {this.exibeComplemento(end)} {end.bairro.length > 0 ? `- ${end.bairro}` : ''}</span>
                                                                        </div>
                                                                        <div className="col-12 text-left">
                                                                            <span>{end.cidade}, {end.uf} - {end.pais}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {this.state.mensagem && (
                                                                <React.Fragment>
                                                                    {index === this.state.indexEnderecoSelecionado && (
                                                                        <div className='col-12 text-center text-danger'>
                                                                            <span><i><strong>Entrega indisponível</strong></i></span>
                                                                        </div>
                                                                    )}
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })}
                                        {this.props.freteAtivo && (
                                            <div className="offset-4 col-4 text-center align-items-center d-flex">
                                                {this.props.isLoadingFrete ? (
                                                    <div className="row no-gutters w-100 text-center py-2">
                                                        <div className="col-12 text-center py-2">
                                                            <div className="spinner-border text-primary" role="status" />
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div className="row no-gutters w-100">
                                                        <div className="col-12 py-1">
                                                            <h6>Valor do frete: R$ {this.props.valorFrete.toFixed(2).toString().replace(".", ",")}</h6>
                                                        </div>
                                                        <div className="col-6 py-1">
                                                            <button onClick={this.alterarEndereco} className="btn btn-outline-info">alterar endereço</button>
                                                        </div>
                                                        <div className='col-6 py-1'>
                                                            <button className='btn btn-outline-secondary' onClick={this.modalEscolherFrete}>Alterar frete</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}
                                {this.state.mensagem && (
                                    <div className="col-12 text-center text-danger py-2">
                                        <span><i><strong>{this.state.mensagem}</strong></i></span>
                                    </div>
                                )}
                                {!this.props.freteAtivo && (
                                    <div className="row no-gutters py-2">
                                        <div className="col-12 text-center py-2">
                                            {this.props.isLoadingFrete ? (
                                                <div className="row no-gutters w-100 text-center py-2">
                                                    <div className="col-12 text-center py-2">
                                                        <div className="spinner-border text-primary" role="status" />
                                                    </div>
                                                </div>
                                            ) : (
                                                <React.Fragment>
                                                    <button onClick={this.calcularFrete} disabled={this.props.enderecos.length <= 0} className="btn btn-outline-info mr-3">calcular frete</button>
                                                    <button className='btn btn-outline-purple mr-3' onClick={this.verificarRestricaoEntrega}>verificar restrição entrega</button>

                                                </React.Fragment>
                                            )}
                                        </div>

                                        <div className="col-12 text-center py-2">
                                            <button onClick={this.toggleModalEndereco} className="btn btn-outline-success">cadastrar novo endereço</button>
                                        </div>
                                        {/* {this.props.cepNaoEntrega && (
                                            <div className="col-12 text-center py-2">
                                                <small className="text-danger">Serviço de entrega indisponível para esse endereço.</small>
                                            </div>
                                        )} */}

                                    </div>
                                )}
                            </div>
                        )
                        }
                    </div>
                </div >
                <Modal size="lg" isOpen={this.state.modalEndereco} toggle={this.toggleModalEndereco}>
                    <ModalBody>
                        <ModalHeader toggle={this.toggleModalEndereco}>Cadastro de novo endereço</ModalHeader>
                        <NewAddress
                            salvarEndereco={this.salvarEndereco}
                            toggle={this.toggleModalEndereco}
                            buscaCEP={this.props.buscaCEP}
                            endereco={this.props.endereco}
                            isLoadingEndereco={this.state.isLoadingEndereco}
                        />
                    </ModalBody>
                </Modal>
            </div >
        );
    }
}

export default OpcaoEntrega;